import { hasInMeta, hasSameStoreMeta, smartRedirect, isSkipRouteLoading } from 'Utils/router';
import store from 'Store';
import { httpClientCMS } from 'Api/microservice-http-clients';
import { requestAuth } from './resolve-auth';

async function getStoreRequestPromises(to, from) {
  const promises = [];
  to.matched.forEach((entry) => {
    if (
      // If store meta exist
      entry?.meta?.store
      // If previous route doesn't exist or url is changed
      && (!from.name || to.path !== from.path)
      // If this store meta didn't loaded in previous route
      // or route the same and it single for some instance (e.g. blog)
      && (
        !hasSameStoreMeta(from, entry.meta.store)
        // for meta updatesStoreData slug should to be changed
        || (hasInMeta(to, 'updateStoreData') && to.params.slug !== from.params.slug)
        || (from.name === to.name && from.name.includes('single'))
      )
    ) {
      entry.meta.store.forEach((action) => {
        const params = { ...to.params, query: to.query };
        params.slug = params.slug || entry.name;
        promises.push(store.dispatch(action, params));
      });
    }
  });

  return promises;
}

export async function checkResponsesOnRedirect(responses, to, from, next) {
  const promises = [];
  responses.forEach((response) => {
    if (
      // it has slug, probably it cms page data
      response?.slug
      // it has redirect_to param
      && response.redirect_to
      // it doesn't have skip cms redirect in route meta
      && !hasInMeta(to, 'skipCMSRedirectTo')
    ) {
      // then redirect
      promises.push(smartRedirect(response.redirect_to, next, from));
      // Check if slug for this page is changed
    } else if (
      // If yes
      response.is_slug_changed
      // and request to old slug
      && response.slug !== to.params.slug
    ) {
      // redirect to current slug from response
      promises.push(smartRedirect(response.slug, next, from));
    }
  });
  await Promise.all(promises);
  return responses;
}

export function onResponseError(error, to, from, next) {
  const status = error.response?.status;
  if (status === 404 && !window.__prerender) {
    // Log original url on 404 redirection
    httpClientCMS.post('404', { url: window.location.origin + to.fullPath });
    // add request url to query as url
    next({ name: '404', replace: !from.name, query: { url: to.fullPath } });
  }
  if (status === 403 && !window.__prerender) {
    // request login on 403 error
    requestAuth(to, from, next);
  }
  if (status >= 500 || error.message === 'Failed to fetch') {
    const name = status ? 'error-code' : 'error';
    if (from.name === name) next(new Error('cancel'));
    else next({ name, replace: !from.name, params: { code: status } });
    throw new Error('Error to fetch dependency');
  }
}

/**
 * Dispatch action from meta store array
 */
export async function resolveStore(to, from, next) {
  const promises = await getStoreRequestPromises(to, from);
  // If route has `skipRouteLoading` - Do transition w/o waiting for all dependency to be resolved
  // but not for prerender
  if (isSkipRouteLoading(to, from) && !window._prerender) return;
  try {
    const responses = await Promise.all(promises);
    await checkResponsesOnRedirect(responses, to, from, next);
  } catch (error) {
    onResponseError(error, to, from, next);
  }
}
